import { TreeTable } from "primereact/treetable";
import { Column } from "primereact/column";
import { InputText } from "primereact/inputtext";
import { useState, useEffect } from "react";

import withName from "../../hoc/withName";
import LoadingDialog from "../Utils/LoadingDialog";
import { Button } from "primereact/button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";


const TreeTablePrime = ({nodes, fields,  header, editableRow, t,editFunction, tableName,loading, editButtonProps,horizontalScroll, removableSort=null,  ...treeTableprops}) => {

    const [globalFilter, setGlobalFilter] = useState(null);


    const renderHeader = () => {
        return (
            <div className="flexDisplay justify-content-end">
                <div>
                    <div className="p-inputgroup flex-1">
                        <InputText type="search" className="inputHeaderTable" onInput={(e) => setGlobalFilter(e.target.value)} placeholder={t("forms.search")} />
                        <span className="p-inputgroup-addon inputIconTables inputHeaderTable">
                            <i className="pi pi-search" />
                        </span>
                    </div>
                </div>
            </div>
        );
    };
    const searchHeader = renderHeader();
    const rowClassName = (node) => {
        return { "treeTablePrimeRows": (node) };
    };
    const editBtn = (rowData) => {
        return(
            <Button type="button" rounded text aria-label="Edit" severity="secondary" onClick={(event) => {
                if(editFunction){
                    editFunction(event, rowData);
                }
            }} {...editButtonProps}
            >
                <FontAwesomeIcon icon={faPencilAlt} size="lg" />
            </Button>);
    };
    return (
        <>
            {loading?<LoadingDialog />:null}
            {nodes?.lenght ===0 || !nodes ?
                <div className="no-data"> {t("forms.noData")}</div>
                :
                <TreeTable
                    className={`treeTablePrime ${treeTableprops.scrollable && nodes.lenght>5?"not-scrollable":""}`} value={nodes} globalFilter={globalFilter}
                    rowClassName={rowClassName} header={header==="search"?searchHeader:header} {...treeTableprops}  removableSort={removableSort !== null?removableSort:true}
                >
                    {fields.map((col, i) => {
                        if (!col.hidden) {
                            const bodyProps ={};
                            const headerProps ={};
                            if(horizontalScroll){
                                bodyProps.width = "250px";
                                headerProps.width = "250px";
                            }else{
                                bodyProps.width = `${100/fields.lenght}%`;
                                headerProps.width = `${100/fields.lenght}%`;
                            }
                            return (
                                <Column
                                    key={`${i}-${tableName}`}
                                    headerClassName="treeTablePrimeHeader"
                                    bodyStyle={{textAlign:"center",...col.bodyStyle, ...bodyProps}}
                                    headerStyle={{textAlign:"center",...col.headerStyle, ...headerProps}}
                                    {...col}
                                />
                            );
                        }
                        else{
                            return null;
                        }
                    })}
                    {editableRow?<Column headerClassName="treeTablePrimeHeader" body={editBtn}  header={t("forms.opciones")} bodyStyle={horizontalScroll?{display:"flex", justifyContent:"center", width:"200px", background:"#d6eff3"}:{display:"flex", justifyContent:"center", width:"200px"}} headerStyle={horizontalScroll?{display:"flex", justifyContent:"center", width:"200px"}:{display:"flex", justifyContent:"center", width:"200px"}} />:null}
                </TreeTable>}
        </>
    );
};

export default withName(TreeTablePrime, "TreeTablePrime");
